<template>
  <tbody>
    <DataListDisplayTableBodyRow
      v-for="(item, index) in items"
      :index="index"
      :key="item.id"
      :record="item"
      :item="item"
      :columns="columns"
      :shouldBulkControlEnabled="shouldBulkControlEnabled"
    >
      <slot />
    </DataListDisplayTableBodyRow>
  </tbody>
</template>
<script lang="ts">
import { inject } from 'vue'
import { registerComposableComponentSettings } from '../../../../../ComposableComponents'
import { DataListDisplayService } from '../DataListDisplayService'

const name = 'DataListDisplayTableBody'
registerComposableComponentSettings(name, {
  hasDefaultSlot: true,
})

export default {
  name: name,
  setup() {
    return {
      items: inject<any[]>('items'),
      DataListDisplayServiceInstance: inject(
        'DataListDisplayServiceInstance',
      ) as DataListDisplayService,
    }
  },
  computed: {
    columns() {
      return this.DataListDisplayServiceInstance.columns
    },
    shouldBulkControlEnabled() {
      return this.DataListDisplayServiceInstance.shouldBulkControlEnabled
    },
  },
}
</script>
